export const sortCategorias = (c1, c2) => {
    return c1.posicion - c2.posicion;
}